export default __webpack_public_path__ + "static/media/photo--lg--wheel-2.05c5041d.jpg";